import { Popper as AkPopper, type CustomPopperProps as AkPopperProps } from '@atlaskit/popper/main';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ChoreographerUtilities,
} from '../../types';
import { wrapComponentForChoreographer } from '../utils';

export const Popper: {
	({
		shouldBeChoreographed,
		withChoreographedRender,
		...props
	}: AkPopperProps<undefined> &
		ChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapComponentForChoreographer<AkPopperProps<undefined>>(AkPopper);
